'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-6a5a8a7f.js');
var React = require('react');
var layout = require('@amzn/stencil-react-components/layout');
require('@amzn/stencil-react-components/icons');
var SurgePremium = require('./SurgePremium-9eee1b19.js');
var text = require('@amzn/stencil-react-components/text');
require('@amzn/stencil-react-theme-default');
var context = require('@amzn/stencil-react-components/context');
var utils = require('@amzn/stencil-react-components/utils');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/*
 * NOTE:
 *
 * This source file was temporarily copied from the 'native-components' package.  Minimal changes
 * were made to use the Stencil web package and associated APIs to provide web support for this
 * component.  This is phase 1 of a multi-phase process to align Stencil native and web APIs so
 * we can more easily manage a single code base for both native and web.  When possible, this
 * component will be re-unified with its native counterpart and duplicate code removed.
 *
 * Ref: https://sim.amazon.com/issues/AtoZPirates-483
 */
exports.BadgeColor = void 0;

(function (BadgeColor) {
  BadgeColor["BLUE"] = "#117EC4";
  BadgeColor["ORANGE"] = "#F4980A";
  BadgeColor["RED"] = "#C1160A";
  BadgeColor["PURPLE"] = "#8800A8";
  BadgeColor["SILVER"] = "#828282";
  BadgeColor["GOLD"] = "#85714D";
  BadgeColor["GREEN"] = "#B5F390";
  BadgeColor["YELLOW"] = "#FFF7B7";
  BadgeColor["WHITE_WITH_BLUE_BORDER"] = "#F3F3F3";
  BadgeColor["DEFAULT"] = "transparent";
})(exports.BadgeColor || (exports.BadgeColor = {}));

var AvatarImage = context.styledWithTheme('div', {
  shouldForwardProp: utils.filterProps(['src'])
})(function (_ref) {
  var src = _ref.src,
      selectors = _ref.theme.selectors;
  return {
    flexShrink: 0,
    backgroundColor: selectors.color('neutral0'),
    backgroundImage: "url('".concat(src, "')"),
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '112px',
    width: '112px'
  };
});
var RowAvatarImage = context.styledWithTheme(layout.Row)(function () {
  return {
    borderStyle: 'solid',
    borderWidth: "4px",
    position: 'absolute',
    top: '-68px',
    width: '120px'
  };
});
var ColBanner = context.styledWithTheme(layout.Col)(function (_ref2) {
  var selectors = _ref2.theme.selectors;
  return {
    alignItems: 'flex-end',
    backgroundColor: selectors.color('neutral90'),
    flex: 1,
    justifyContent: 'flex-end',
    paddingBottom: '18px',
    paddingInlineEnd: '22px' // RTL version of padding-right

  };
});
var ColTextBlock = context.styledWithTheme(layout.Col)(function (_ref3) {
  var selectors = _ref3.theme.selectors;
  return {
    // Since setting both padding left and right to same value, don't need to use RTL properties.
    paddingLeft: utils.px(selectors.space('S400')),
    paddingRight: utils.px(selectors.space('S400')),
    paddingBottom: utils.px(selectors.space('S300')),
    position: 'relative'
  };
});
var TextTitleTag = context.styledWithTheme(text.Text)(function (_ref4) {
  var selectors = _ref4.theme.selectors;
  return {
    alignSelf: 'center',
    backgroundColor: selectors.color('neutral90'),
    borderRadius: '4px',
    borderWidth: '1px',
    color: selectors.color('neutral0'),
    overflow: 'hidden',
    paddingBottom: '2px',
    // Since setting both padding left and right to same value, don't need to use RTL properties.
    paddingLeft: utils.px(selectors.space('S100')),
    paddingRight: utils.px(selectors.space('S100')),
    paddingTop: '2px',
    textTransform: 'uppercase'
  };
});

var Banner = function Banner() {
  return /*#__PURE__*/React__default["default"].createElement(ColBanner, null, /*#__PURE__*/React__default["default"].createElement(SurgePremium.IconAmazonSmile, null));
};

function EmployeeAvatarCard(_ref5) {
  var fullName = _ref5.fullName,
      BannerContent = _ref5.BannerContent,
      profileImageUri = _ref5.profileImageUri,
      badgeBorderColor = _ref5.badgeBorderColor,
      titleTag = _ref5.titleTag,
      imageAccessibilityLabel = _ref5.imageAccessibilityLabel,
      children = _ref5.children;

  // _sjc: TODO: Get this to work...
  // const DefaultBadgePhoto = require('../assets/images/default-badge-photo.png');
  var getBanner = function getBanner() {
    return BannerContent || /*#__PURE__*/React__default["default"].createElement(Banner, null);
  };

  var _useState = React.useState('transparent'),
      _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
      borderColorProp = _useState2[0],
      setBorderColorProp = _useState2[1];

  var getTitleTag = function getTitleTag() {
    if (titleTag && titleTag.length > 0) {
      return /*#__PURE__*/React__default["default"].createElement(TextTitleTag, {
        fontSize: "T200",
        dataTestId: "titleTag"
      }, titleTag);
    }

    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  };

  React.useEffect(function () {
    if (badgeBorderColor && badgeBorderColor !== exports.BadgeColor.DEFAULT) {
      setBorderColorProp(badgeBorderColor);
    }
  }, [badgeBorderColor]);
  return /*#__PURE__*/React__default["default"].createElement(layout.Col, null, /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    height: "126px"
  }, getBanner()), /*#__PURE__*/React__default["default"].createElement(ColTextBlock, {
    gridGap: "4px"
  }, /*#__PURE__*/React__default["default"].createElement(RowAvatarImage, {
    style: {
      borderColor: borderColorProp
    },
    dataTestId: "avatarWrapper"
  }, /*#__PURE__*/React__default["default"].createElement(AvatarImage, {
    "aria-label": imageAccessibilityLabel,
    role: "img",
    src: profileImageUri
  })), /*#__PURE__*/React__default["default"].createElement(layout.Spacer, {
    height: "64px"
  }), /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    gridGap: "S300",
    flexWrap: "wrap"
  }, /*#__PURE__*/React__default["default"].createElement(text.Text, {
    fontSize: "T500",
    fontWeight: "bold"
  }, fullName), getTitleTag()), /*#__PURE__*/React__default["default"].createElement(layout.Col, null, children)));
}

exports.EmployeeAvatarCard = EmployeeAvatarCard;
//# sourceMappingURL=EmployeeAvatarCard-7f8b0099.js.map
